// Updated to use modern import approach instead of imports-loader
// This is necessary after upgrading to Node.js 20.19.0 and Yarn 3.8.7
// as the imports-loader syntax is no longer working correctly

// Import jQuery and make it global
import $ from 'jquery'
window.jQuery = $

// Import jQuery UI components
import 'jquery-ui/autocomplete'
import 'jquery-ui/dialog'
import 'jquery-ui/sortable'

// Import jQuery plugins using require for better compatibility
require('jquery-autosize')
require('dotdotdot')
require('jquery-ujs')
require('jquery-validation')
require('jquery-validation/dist/additional-methods')
require('jquery.payment')

// Import other dependencies
import 'legacy/jquery/globals'
import './kill_white_space'

// Import local jQuery plugins
require('./placeholder')
require('./triggered_autocomplete')
require('./tipsy')
require('./livequery')
